import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function getBookingChannelConfigList(data) {
  return request({
    url: URL.mdm.bookingChannelConfig.channelConfigList,
    method: 'post',
    data
  })
}

// 新增/修改
export function saveBookingChannelConfig(data) {
  return request({
    url: URL.mdm.bookingChannelConfig.channelConfig,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 删除
export function delBookingChannelConfig(data) {
  return request({
    url: URL.mdm.bookingChannelConfig.channelConfig,
    method: 'delete',
    data
  })
}
